import CustomHeader from "@/components/CustomHeader/CustomHeader";
import Pagination from "@/components/Table/Pagination";
import Table from "@/components/Table/Table";
import { useSearchPagination } from "@/hooks/useSearchPagination";
import { showHyphen } from "@/lib/hyphen";
import toast from "@/lib/toast";
import { formatAmount } from "@/lib/utils";
import productCatalogueService from "@/services/api/Product Catalogue/ProductCatalogue";
import AllOrdersService from "@/services/api/RetailerModuleService/RAllOrders";
import { useEffect, useState } from "react"

const DisProductCatalogue = () => {
    const [catalogueData,setCatalogueData] = useState<any[]>([]);
    const [totalRecords, setTotalRecords] = useState<number | null>(null);
    const DistributorId = localStorage.getItem("disretailerId");
    const currency = localStorage.getItem("currency");

    
    const catalogueColumn = [
        { name: "Product Name", selector: (row: any) => row.productName },
        { name: "SKU Code", selector: (row: any) => row.skuCode },
        { name: "Scheme", selector: (row: any) => showHyphen(row.scheme) },
        { name: "Total Qty", selector: (row: any) => row.qty },  
        { name: `Selling Price (${currency})`, selector: (row: any) =><span>{formatAmount(row.sellingPrice)}</span> },  
    ];

    const {
        debouncedSearch,
        search,
        setSearch,
        pageSelected,
        setPageSelected,
        rowsPerPageValue,
        setRowsPerPageValue,
    } = useSearchPagination();

    const from = (pageSelected - 1) * rowsPerPageValue + 1;
    const to = pageSelected * rowsPerPageValue;

    const fetchProductCatalogue = async () => {
        const params = {
            from,
            to,
            search : debouncedSearch || "",
            distributorId : DistributorId
        }
        try{
            const res = await AllOrdersService.getDistributorProductList(params);
            setCatalogueData(res?.data?.items || []);
            setTotalRecords(res?.data?.totalRecords);
        }catch(err : any){
            toast.error(err?.message);
        }
    }

    
    useEffect(() => {
        fetchProductCatalogue();
    },[pageSelected,debouncedSearch])
    return (
        <>
        <div className="p-5">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl md:text-lg font-semibold">Product Catalogue</h2>
          <div className="flex items-center gap-3">
            <CustomHeader
              search={search}
              setSearch={setSearch}
            />
          </div>
        </div>
        <Table columns={catalogueColumn} data={catalogueData ?? []}/>
            <Pagination
                isPagination={true}
                totalCount={totalRecords ?? 0}
                pageSelected={pageSelected}
                setPageSelected={setPageSelected}
                rowsPerPageValue={rowsPerPageValue}
                setRowsPerPageValue={setRowsPerPageValue}
                customRowsPerPage={false}
            />
        </div>
        </>
    )
}

export default DisProductCatalogue